import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/HeroSection';
import FeaturesIntro from '../components/FeaturesIntro';
import FeatureShowcase from '../components/FeatureShowcase';
import FAQSection from '../components/FAQSection';
import PricingSection from '../components/PricingSection';
import DownloadCTA from '../components/DownloadCTA';
import { useTheme } from '../context/ThemeContext';

const Home = () => {
  const { isDark } = useTheme();
  const sectionBg = isDark ? 'bg-[#0E1314]' : 'bg-[#EFF6F2]';
  const altBg = isDark ? 'bg-[#0A0F0E]' : 'bg-[#F7FAF8]';

  return (
    <>
      <Helmet>
        <title>Vuzo | AI Productivity in Your Browser</title>
        <meta name="description" content="Get unlimited access to advanced AI tools with Vuzo: your all-in-one smart assistant powered by GPT-5.4 Pro, Gemini 2.5 Flash, Claude Sonnet, and more. Start for free at chat.vuzo.com." />
      </Helmet>
      <HeroSection />
      <section className="relative overflow-hidden px-0">
        <div id="features" className={`w-full ${sectionBg}`}>
          <div className="max-w-[1280px] mx-auto md:px-2">
            <FeaturesIntro />
            <FeatureShowcase />
          </div>
        </div>
        <div id="faq" className={`w-full ${altBg}`}>
          <div className="max-w-[1280px] mx-auto px-4 md:px-12 2xl:px-4">
            <FAQSection />
          </div>
        </div>
        <div id="pricing" className={`w-full ${sectionBg}`}>
          <PricingSection />
        </div>
        <div id="download" className={`w-full ${altBg}`}>
          <div className="max-w-[1280px] mx-auto">
            <DownloadCTA />
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
